export const AdministrativeRank = {
    RP: 3,
    DISTRICT: 4,
    COMMUNE: 6
};


// WEBPACK FOOTER //
// ./js/Constants.js